const theme = {
  primary: '#6050DC',
  secondary: '#0B0826',
  darkGrey: '#212121',
  lightGrey: '#DEDEDF',
  grey: '#909090'
}

export default theme
